export default __webpack_public_path__ + "static/media/phone.c607ebce.png";